import { render, staticRenderFns } from "./userRatingList.vue?vue&type=template&id=ab06a8ba&scoped=true&"
import script from "./userRatingList.vue?vue&type=script&lang=js&"
export * from "./userRatingList.vue?vue&type=script&lang=js&"
import style0 from "./userRatingList.vue?vue&type=style&index=0&id=ab06a8ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab06a8ba",
  null
  
)

export default component.exports